import { getSafeRedirect } from 'payload/shared';

/** `loginRedirectParam` encodes twice, so its value still reads encoded here. Payload's own login redirects are already a path. */
const resumePath = (redirect: string | null): string => {
  if (redirect === null) return '';
  if (redirect.startsWith('/')) return redirect;
  return getSafeRedirect({ redirectTo: redirect, fallbackTo: '' });
};

/**
 * Sends the login page's `?redirect=` to Google as `state`, which comes back on the callback for
 * `successRedirect` to resume. Without it an interrupted flow always lands on /admin.
 */
export const googleLoginHref = (redirect: string | null): string => {
  const destination = resumePath(redirect);
  return `/api/users/oauth/google${destination ? `?state=${encodeURIComponent(destination)}` : ''}`;
};
